
import React from 'react'
import {Card} from 'react-bootstrap';
import paginationFactory, {PaginationProvider} from 'react-bootstrap-table2-paginator';
import {Pagination} from 'src/_metronic/_partials/controls';
import BootstrapTable, {SortOrder} from 'react-bootstrap-table-next';
import {NoRecordsFoundMessage, PleaseWaitMessage, toAbsoluteUrl} from 'src/_metronic/_helpers';

import {Link} from 'react-router-dom';
import SVG from 'react-inlinesvg';

import { TableNoData } from 'src/_metronic/layout/components/TableNoData';
import {useParkingProvider} from '../Context/ParkingContext'

import { Header } from '../Components/Header';
import { Modals } from '../Components/Modals';

export function List(){
  const {tableConfig,modals} = useParkingProvider()
  const {columns,loadingDataToTable, optionPagination, data, alterProps} = tableConfig 
  const {modalToggle,parkingSelectedToModal} = modals

  function RenderAction(item: any) {
    if (item.isEnabled) {
      return (
        <>
          <Link
            className='btn btn-icon btn-light btn-hover-primary btn-sm mx-3'
            to={`/parkingregister/manager`}
            onClick={() => {
              sessionStorage.setItem('@CONTROLID@/parking/edit', item.id);
            }}>
            <span className='svg-icon svg-icon-md svg-icon-primary'>
              <SVG src={toAbsoluteUrl('/media/svg/icons/Communication/Write.svg')} />
            </span>
          </Link>

          <a
            className='btn btn-icon btn-light btn-hover-danger btn-sm mx-3'
            onClick={() => {
              // handleDelete(item.id, item.personName);
              console.log(item)
              parkingSelectedToModal(item.id, item["0"])
              modalToggle('delete')
            }}>
            <span className='svg-icon svg-icon-md svg-icon-danger'>
              <SVG src={toAbsoluteUrl('/media/svg/icons/General/Trash.svg')} />
            </span>
          </a>
        </>
      );
    } 

    return (
      <>
        <a
          className='btn btn-icon btn-icon btn-light btn-hover-success btn-sm mx-3'
          onClick={() => {
            parkingSelectedToModal(item.id, item.name)
            modalToggle('reactive')
          }}>
          <span className='svg-icon svg-icon-md svg-icon-success'>
            <SVG src={toAbsoluteUrl('/media/svg/icons/Navigation/Check.svg')} />
          </span>
        </a>
      </>
    );
  }

const dataToRender = data.map( item => {

  console.log({item})
  return{
    ...item,
    '1':item['1'] === 0 ? '-':item['1'],
    '2':RenderAction(item)
  }
})

const columnsToRender= columns
    // .filter((_, index) => columnIndexActivedVisitorExpired.includes(index + 1))
.map((item: any, index) => {
      if (index === 0) {
        delete item.align;
        delete item.headerAlign;

        item.style = {
          minWidth: '170px'
        };
        return item;
      }

      

      return item;
});



  return (
    <>
      <Card style={{marginTop: 80}} className={'card card-custom gutter-b mt-md-0'}>
        <Header />
        <Card.Body>
        <PaginationProvider
          pagination={paginationFactory(            
            optionPagination
          )}>
          {({paginationProps, paginationTableProps}: any) => {
            // console.log('paginationProps',paginationProps)
            return (
              <Pagination isLoading={false} paginationProps={paginationProps}>
               
                {loadingDataToTable ? (
                  <TableNoData columnsToTable={columns} paginationTableProps={paginationTableProps} />
                ) : (
                  <BootstrapTable
                    onTableChange={(type, props) => {
                      
                      alterProps(type, props)

                      // if(type === 'pagination'){
                      //   handlerAlterLimitItens(props.sizePerPage)

                      //   if (props.page !== 0) {
                      //      handlerAlterPage(props.page);
                      //   }
                      // }

                      // setSizePerPage(props.sizePerPage);
                    }}
                    // defaultSorted={[defaultSortedColumn]}
                    wrapperClasses='table-responsive'
                    bordered={false}
                    classes='table table-head-custom table-vertical-center overflow-hidden'
                    remote
                    bootstrap4
                    keyField='id'
                    data={dataToRender}
                    columns={columnsToRender}
                    {...paginationTableProps}>

                    <PleaseWaitMessage entities={dataToRender} />
                    <NoRecordsFoundMessage entities={[dataToRender]} />
                
                  </BootstrapTable>
                )}
              </Pagination>
            );
          }}
        </PaginationProvider>
        </Card.Body>
      
      </Card>
      <Modals />
    </>
  )
}